import queryString from "query-string";

export default function log(...message: any) {
  const params = queryString.parse(window.location.search);
  if (window.location.hostname === "localhost" || params.log) {
    console.log.apply(console, message);
  }
}
